import { Sections } from '../../constants/sections';

let sections = [
  {
    id: Sections.HOME,
    name: 'home',
    className: 'home',
    color: '#5DD5ED',
    worksheetList: []
  },
  {
    id: Sections.PRE_K,
    name: 'preKName',
    subtitle: 'preKSubtitle',
    className: 'pre-k',
    color: '#94CE39',
    worksheetList: [
      {
        id: 0,
        enabled: true,
        sheetName: 'myName',
        pageLayout: 'landscape',
        thumbnailImage: 'aplus-worksheet-maker-prek-my-name.png'
      },
      {
        id: 1,
        enabled: true,
        sheetName: 'myPicture',
        pageLayout: 'landscape',
        thumbnailImage: 'aplus-worksheet-maker-prek-my-picture.png'
      },
      {
        id: 2,
        enabled: true,
        sheetName: 'certificateOfCompletion',
        thumbnailImage: 'aplus-worksheet-maker-prek-cert-of-completion.png',
        pageLayout: 'landscape',
        emptyTextList: ['NAME', '301-555-7700']
      },
      {
        id: 3,
        enabled: true,
        sheetName: 'myNameTitlecase',
        pageLayout: 'landscape',
        thumbnailImage: 'aplus-worksheet-maker-prek-my-name-titlecase.png'
      },
      {
        id: 4,
        enabled: true,
        sheetName: 'nameTracing',
        pageLayout: 'landscape',
        thumbnailImage: 'aplus-worksheet-maker-prek-name-tracing.png'
      }
    ]
  },
  {
    id: Sections.KIDERGARDEN,
    name: 'kg1Name',
    subtitle: 'kg1Subtitle',
    className: 'kindergarden',
    color: '#FF9136',
    worksheetList: [
      {
        id: 10,
        enabled: true,
        sheetName: 'myPicture',
        pageLayout: 'landscape',
        thumbnailImage: 'aplus-worksheet-maker-kg-to-1st-my-picture.png'
      },
      {
        id: 11,
        enabled: true,
        sheetName: 'nameInTitlecase',
        thumbnailImage: 'aplus-worksheet-maker-kg-to-1st-name-titlecase.png',
        pageLayout: 'landscape'
      },
      {
        id: 12,
        enabled: true,
        sheetName: 'words',
        thumbnailImage: 'aplus-worksheet-maker-kg-to-1st-words.png',
        pageLayout: 'landscape'
      },
      {
        id: 13,
        enabled: true,
        sheetName: 'spelling',
        thumbnailImage: 'aplus-worksheet-maker-kg-to-1st-spelling.png',
        pageLayout: 'landscape'
      },
      {
        id: 14,
        enabled: true,
        sheetName: 'vocabulary',
        thumbnailImage: 'aplus-worksheet-maker-kg-to-1st-vocabulary.png',
        pageLayout: 'landscape'
      },
      {
        id: 15,
        enabled: false,
        sheetName: 'sentence',
        thumbnailImage: 'aplus-worksheet-maker-kg-to-1st-sentence.png',
        pageLayout: 'landscape'
      },
      {
        id: 16,
        enabled: false,
        sheetName: 'myOpinion',
        thumbnailImage: 'aplus-worksheet-maker-kg-to-1st-my-opinion.png',
        pageLayout: 'landscape'
      },
      {
        id: 17,
        enabled: false,
        sheetName: 'opinion',
        thumbnailImage: 'aplus-worksheet-maker-kg-to-1st-opinion.png',
        pageLayout: 'landscape'
      },
      {
        id: 171,
        enabled: false,
        sheetName: 'highFrequencyWordCards',
        thumbnailImage: 'aplus-worksheet-maker-kg-to-1st-word-cards.png',
        pageLayout: 'landscape'
      },
      {
        id: 172,
        enabled: false,
        sheetName: 'nameLabels',
        thumbnailImage: 'aplus-worksheet-maker-kg-to-1st-name-labels.png',
        pageLayout: 'landscape'
      },
      {
        id: 173,
        enabled: false,
        sheetName: 'nameTracing',
        thumbnailImage: 'aplus-worksheet-maker-kg-to-1st-name-tracing.png',
        pageLayout: 'landscape'
      },
      {
        id: 18,
        enabled: false,
        sheetName: 'certificateOfCompletionWhale',
        thumbnailImage: 'aplus-worksheet-maker-kg-to-1st-cert-of-completion-whale.png',
        pageLayout: 'landscape',
        emptyTextList: ['NAME', '301-555-7700']
      },
      {
        id: 19,
        enabled: false,
        sheetName: 'certificateOfCompletionEagle',
        thumbnailImage: 'aplus-worksheet-maker-kg-to-1st-cert-of-completion-eagle.png',
        pageLayout: 'landscape'
      }
    ]
  },
  {
    id: Sections.GRADE_1,
    name: '12Name',
    subtitle: '12Subtitle',
    className: 'grade-1',
    color: '#FEE41C',
    worksheetList: [
      {
        id: 20,
        enabled: true,
        sheetName: 'wordsSpelling',
        thumbnailImage: 'aplus-worksheet-maker-1st-to-2nd-word-spelling.png',
        pageLayout: 'portrait'
      },
      {
        id: 21,
        enabled: true,
        sheetName: 'vocabulary',
        thumbnailImage: 'aplus-worksheet-maker-1st-to-2nd-vocabulary.png',
        pageLayout: 'portrait'
      },
      {
        id: 211,
        enabled: true,
        sheetName: 'sentence',
        thumbnailImage: 'aplus-worksheet-maker-1st-to-2nd-sentence-org.png',
        pageLayout: 'portrait'
      },
      {
        id: 22,
        enabled: true,
        sheetName: 'sequenceGraphicOrganizer',
        thumbnailImage: 'aplus-worksheet-maker-1st-to-2nd-sequence-graphic-org.png',
        pageLayout: 'portrait'
      },
      {
        id: 23,
        enabled: true,
        sheetName: 'graphicOrganizer',
        thumbnailImage: 'aplus-worksheet-maker-1st-to-2nd-graphic-org.png',
        pageLayout: 'portrait'
      },
      {
        id: 24,
        enabled: true,
        sheetName: 'storyOrganizer',
        thumbnailImage: 'aplus-worksheet-maker-1st-to-2nd-story-org.png',
        pageLayout: 'portrait'
      },
      {
        id: 25,
        enabled: false,
        sheetName: 'myOpinion',
        thumbnailImage: 'aplus-worksheet-maker-1st-to-2nd-my-opinion.png',
        pageLayout: 'portrait'
      },
      {
        id: 251,
        enabled: false,
        sheetName: 'highFrequencyWordCards',
        thumbnailImage: 'aplus-worksheet-maker-1st-to-2nd-word-cards.png',
        pageLayout: 'portrait'
      },
      {
        id: 252,
        enabled: false,
        sheetName: 'nameLabels',
        thumbnailImage: 'aplus-worksheet-maker-1st-to-2nd-name-labels.png',
        pageLayout: 'portrait'
      },
      {
        id: 253,
        enabled: false,
        sheetName: 'nameTracing',
        thumbnailImage: 'aplus-worksheet-maker-1st-to-2nd-name-tracing.png',
        pageLayout: 'landscape'
      },
      {
        id: 26,
        enabled: false,
        sheetName: 'certificateOfCompletionSwordfish',
        thumbnailImage: 'aplus-worksheet-maker-1st-to-2nd-cert-of-completion-swordfish.png',
        pageLayout: 'landscape'
      },
      {
        id: 27,
        enabled: false,
        sheetName: 'certificateOfCompletionCroc',
        thumbnailImage: 'aplus-worksheet-maker-1st-to-2nd-cert-of-completion-croc.png',
        pageLayout: 'landscape'
      }
    ]
  },
  {
    id: Sections.GRADE_2,
    name: '23Name',
    subtitle: '23Subtitle',
    className: 'grade-2',
    color: '#00C9BF',
    worksheetList: [
      {
        id: 30,
        enabled: true,
        sheetName: 'wordsSpelling',
        thumbnailImage: 'aplus-worksheet-maker-2nd-to-3rd-word-spelling.png',
        pageLayout: 'portrait'
      },
      {
        id: 31,
        enabled: true,
        sheetName: 'vocabulary',
        thumbnailImage: 'aplus-worksheet-maker-2nd-to-3rd-vocabulary.png',
        pageLayout: 'portrait'
      },
      {
        id: 311,
        enabled: true,
        sheetName: 'sentence',
        thumbnailImage: 'aplus-worksheet-maker-2nd-to-3rd-sentence-org.png',
        pageLayout: 'portrait'
      },
      {
        id: 32,
        enabled: true,
        sheetName: 'sequenceGraphicOrganizer',
        thumbnailImage: 'aplus-worksheet-maker-2nd-to-3rd-sequence-org.png',
        pageLayout: 'portrait'
      },
      {
        id: 33,
        enabled: true,
        sheetName: 'graphicOrganizer',
        thumbnailImage: 'aplus-worksheet-maker-2nd-to-3rd-graphic-org.png',
        pageLayout: 'portrait'
      },
      {
        id: 34,
        enabled: true,
        sheetName: 'storyOrganizer',
        thumbnailImage: 'aplus-worksheet-maker-2nd-to-3rd-story-org.png',
        pageLayout: 'portrait'
      },
      {
        id: 35,
        enabled: true,
        sheetName: 'myOpinion',
        thumbnailImage: 'aplus-worksheet-maker-2nd-to-3rd-my-opinion.png',
        pageLayout: 'portrait'
      },
      {
        id: 36,
        enabled: true,
        sheetName: 'highFrequencyWordCards',
        thumbnailImage: 'aplus-worksheet-maker-2nd-to-3rd-word-card.png',
        pageLayout: 'portrait'
      },
      {
        id: 37,
        enabled: true,
        sheetName: 'nameLabels',
        thumbnailImage: 'aplus-worksheet-maker-2nd-to-3rd-name-labels.png',
        pageLayout: 'portrait'
      },
      {
        id: 38,
        enabled: true,
        sheetName: 'nameTracing',
        thumbnailImage: 'aplus-worksheet-maker-2nd-to-3rd-name-tracing.png',
        pageLayout: 'landscape'
      },
      {
        id: 380,
        enabled: false,
        sheetName: 'certificateOfCompletionSailboat',
        thumbnailImage: 'aplus-worksheet-maker-2nd-to-3rd-cert-of-completion-sailboat.png',
        pageLayout: 'landscape'
      }
    ]
  },
  {
    id: Sections.GRADE_3,
    name: '3456Name',
    subtitle: '3456Subtitle',
    className: 'grade-3',
    color: '#FF555F',
    worksheetList: [
      {
        id: 40,
        enabled: true,
        sheetName: 'wordsSpellingPrint',
        thumbnailImage: 'aplus-worksheet-maker-3rd-to-4th-word-spelling.png',
        pageLayout: 'portrait'
      },
      {
        id: 41,
        enabled: true,
        sheetName: 'vocabularyPrint',
        thumbnailImage: 'aplus-worksheet-maker-3rd-to-4th-vocabulary.png',
        pageLayout: 'portrait'
      },
      {
        id: 411,
        enabled: true,
        sheetName: 'sentence',
        thumbnailImage: 'aplus-worksheet-maker-3rd-to-4th-sentence-org-print.png',
        pageLayout: 'portrait'
      },
      {
        id: 42,
        enabled: true,
        sheetName: 'sequenceGraphicOrganizerPrint',
        thumbnailImage: 'aplus-worksheet-maker-3rd-to-4th-sequence-graphic-org.png',
        pageLayout: 'portrait'
      },
      {
        id: 43,
        enabled: true,
        sheetName: 'graphicOrganizerPrint',
        thumbnailImage: 'aplus-worksheet-maker-3rd-to-4th-graphic-org.png',
        pageLayout: 'portrait'
      },
      {
        id: 44,
        enabled: true,
        sheetName: 'storyOrganizerPrint',
        thumbnailImage: 'aplus-worksheet-maker-3rd-to-4th-story-org.png',
        pageLayout: 'portrait'
      },
      {
        id: 45,
        enabled: true,
        sheetName: 'myOpinionPrint',
        thumbnailImage: 'aplus-worksheet-maker-3rd-to-4th-my-opinion.png',
        pageLayout: 'portrait'
      },
      {
        id: 46,
        enabled: true,
        sheetName: 'wordsSpellingCursive',
        thumbnailImage: 'aplus-worksheet-maker-3rd-to-4th-word-spelling-cursive.png',
        pageLayout: 'portrait'
      },
      {
        id: 47,
        enabled: true,
        sheetName: 'vocabularyCursive',
        thumbnailImage: 'aplus-worksheet-maker-3rd-to-4th-vocabulary-cursive.png',
        pageLayout: 'portrait'
      },
      {
        id: 471,
        enabled: true,
        sheetName: 'sentenceCursive',
        thumbnailImage: 'aplus-worksheet-maker-3rd-to-4th-sentence-org-cursive.png',
        pageLayout: 'portrait'
      },
      {
        id: 48,
        enabled: true,
        sheetName: 'sequenceGraphicOrganizerCursive',
        thumbnailImage: 'aplus-worksheet-maker-3rd-to-4th-sequence-graphic-org-cursive.png',
        pageLayout: 'portrait'
      },
      {
        id: 49,
        enabled: true,
        sheetName: 'graphicOrganizerCursive',
        thumbnailImage: 'aplus-worksheet-maker-3rd-to-4th-graphic-org-cursive.png',
        pageLayout: 'portrait'
      },
      {
        id: 50,
        enabled: true,
        sheetName: 'storyOrganizerCursive',
        thumbnailImage: 'aplus-worksheet-maker-3rd-to-4th-story-org-cursive.png',
        pageLayout: 'portrait'
      },
      {
        id: 51,
        enabled: true,
        sheetName: 'myOpinionCursive',
        thumbnailImage: 'aplus-worksheet-maker-3rd-to-4th-my-opinion-cursive.png',
        pageLayout: 'portrait'
      },
      {
        id: 52,
        enabled: false,
        sheetName: 'grade3CertificateOfCompletion',
        thumbnailImage: 'aplus-worksheet-maker-3rd-to-4th-cert-of-completion-grade-3.png',
        pageLayout: 'landscape'
      },
      {
        id: 53,
        enabled: false,
        sheetName: 'grade4CertificateOfCompletion',
        thumbnailImage: 'aplus-worksheet-maker-3rd-to-4th-cert-of-completion-grade-4.png',
        pageLayout: 'landscape'
      },
      {
        id: 54,
        enabled: false,
        sheetName: 'grade5CertificateOfCompletionPrint',
        thumbnailImage: 'aplus-worksheet-maker-3rd-to-4th-cert-of-completion-grade-5.png',
        pageLayout: 'landscape'
      },
      {
        id: 55,
        enabled: false,
        sheetName: 'grade5CertificateOfCompletionCursive',
        thumbnailImage: 'aplus-worksheet-maker-3rd-to-4th-cert-of-completion-grade-5-cursive.png',
        pageLayout: 'landscape'
      }
    ]
  }
];

export default sections;
